
export const timezonesByName = {
    "Eastern Time": "America/New_York",
    "Central Time": "America/Chicago",
    "Mountain Time": "America/Denver",
    "Pacific Time": "America/Los_Angeles",
    "Alaskan Time": "America/Anchorage",
    "Hawaii-Aleutian Time": "America/Adak"
}


export const timezonesByLocation = {
    "America/New_York": "Eastern Time",
    "America/Chicago": "Central Time",
    "America/Denver": "Mountain Time",
    "America/Los_Angeles": "Pacific Time",
    "America/Anchorage": "Alaskan Time",
    "America/Adak": "Hawaii-Aleutian Time"
}